import React from "react";

import { InputText, Text } from "@performyard/py-components";

type Props = {
	label: string;
	value: string;
	onChange: (next: string) => void;
	placeholder?: string;
	fallbackSwatchColor?: string;
	ariaDescribedBy?: string;
	disabled?: boolean;
};

const FALLBACK_SWATCH = "#FFFFFF";

const ColorHexInput: React.FC<Props> = ({
	label,
	value,
	onChange,
	placeholder,
	fallbackSwatchColor = FALLBACK_SWATCH,
	ariaDescribedBy,
	disabled,
}) => {
	const swatchColor = value.trim() ? value : fallbackSwatchColor;

	return (
		<div className="flex flex-col gap-2">
			<Text size="paragraph-2" dangerouslySetClassName="font-semibold text-neutral-9">
				{label}
			</Text>
			<div className="flex items-center gap-2">
				<span
					aria-hidden="true"
					className="inline-block h-[26px] w-[26px] shrink-0 rounded-[2px] border border-solid border-neutral-3"
					data-testid={`${label}-swatch`}
					style={{ backgroundColor: swatchColor }}
				/>
				<div className="flex-1">
					<InputText
						value={value}
						onChange={onChange}
						placeholder={placeholder ?? "#FFFFFF"}
						aria-label={label}
						aria-describedby={ariaDescribedBy}
						disabled={disabled}
					/>
				</div>
			</div>
		</div>
	);
};

export default ColorHexInput;
